import People from "@material-ui/icons/People";

export const ChallengeIcon = People;
export { ChallengeCreate } from "./create";
export { ChallengeList } from "./list";
export { ChallengeEdit } from "./edit";
